import { AnyAction } from '@reduxjs/toolkit';
import { GetFeatureFlagsRoutine, GetFeatureUserFlagsRoutine, GetAssignedUsersRoutine } from '~modules/FeatureFlags/redux-routines';
import { UPDATE_SELECTED_FLAG } from '../action-types';

export const initialState = {
  data: [],
  userData: [],
  featureFlagsCategories: [],
  assignedUsers: [],
  selectedFlag: null,
  error: null,
  isFetching: false,
  isFetchingUserFeatureFlags: false,
  isFetchingAssignedUsers: false,
  errorAssignedUsers: null
};

export const featureFlagsReducer = (
  state = initialState,
  action: AnyAction
) => {
  switch (action.type) {
    case GetFeatureFlagsRoutine.REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case GetFeatureFlagsRoutine.SUCCESS: {
      return {
        ...state,
        data: action.payload.featureFlags,
        featureFlagsCategories: action.payload.featureFlagCategories,
        isFetching: false,
      };
    }
    case GetFeatureFlagsRoutine.FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };

    case GetFeatureUserFlagsRoutine.REQUEST:
      return {
        ...state,
        isFetchingUserFeatureFlags: true
      };
    case GetFeatureUserFlagsRoutine.SUCCESS: {
      return {
        ...state,
        userData: action.payload,
        isFetchingUserFeatureFlags: false,
      };
    }
    case GetFeatureUserFlagsRoutine.FAILURE:
      return {
        ...state,
        errorFetchingUserFeatureFlags: action.payload,
        isFetchingUserFeatureFlags: false,
      };
    case GetAssignedUsersRoutine.SUCCESS: {
      return {
        ...state,
        assignedUsers: action.payload.data,
        isFetchingAssignedUsers: false,
      };
    }
    case GetAssignedUsersRoutine.REQUEST: {
      return {
        ...state,
        isFetchingAssignedUsers: true,
      };
    }
    case GetAssignedUsersRoutine.FAILURE:
      return {
        ...state,
        errorAssignedUsers: action.payload,
        isFetchingAssignedUsers: false,
      };

    case UPDATE_SELECTED_FLAG: {
      return {
        ...state,
        selectedFlag: action.payload,
        isFetchingAssignedUsers: false,
      };
    }

    default:
      return state;
  }
};